import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Printer, PrintOptions } from '@ionic-native/printer/ngx';
import { ToastService } from 'src/app/core/toast.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Pedido } from 'src/app/model/pedido';

@Component({
  selector: 'app-pedido-list',
  templateUrl: './pedido-list.page.html',
  styleUrls: ['./pedido-list.page.scss'],
})
export class PedidoListPage implements OnInit {
  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  produtos: Pedido[] = [];
  prod: Pedido;
  inicio = '';
  fim = '';
  user: string;
  pass: string;
  idCategoria;
  data1: string;
  data2: string;
  tipoPedido;

  loading = false;


  constructor(private route: ActivatedRoute,
              private toast: ToastService,
              private pedidoapi: PedidoService,
              private global: GlobalService,
              private printer: Printer) { }



  ngOnInit() {
    this.user = this.global.user;
    this.pass = this.global.pass;

    const idParam = this.route.snapshot.paramMap.get('tipo');
    if (idParam) {

      this.tipoPedido = idParam;
      // tslint:disable-next-line: radix
      this.idCategoria = parseInt(idParam);
      // tslint:disable-next-line: radix
    }

    this.loadProds(idParam);
  }

  ionViewWillEnter() {
    this.user = this.global.user;
    this.pass = this.global.pass;
  }

  async loadProds(idParam) {
    this.loading = true;
    this.pedidoapi.getUltimosPorParam(idParam).then(res => {
      this.produtos = res;
      this.loading = false;
      //this.toast.showSucess('Histórico obtido com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Histórico');
      this.loading = false;
    });
  }

  dataPesquisa() {
    this.loading = true;
    this.data1 = this.data1.replace(/\-/gi, '');
    this.data2 = this.data2.replace(/\-/gi, '');
    this.data1 += '000000';
    this.data2 += '235959';

    this.pedidoapi.getData(this.data1, this.data2).then(res => {
      this.produtos = res;
      this.loading = false;
      // this.toast.showSucess('Histórico obtido com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Histórico');
      this.loading = false;
    });
  }

  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    this.loadProds(this.tipoPedido);
  }

  async doSearchBarChange($event: any) {
    let value = $event.target.value;
    // if (value && value.lenght >= 2) {
      value = value.replace(/\s+/g, "_");
    this.produtos = await this.pedidoapi.GetByNome(value);
    // }
  }
  print() {



    // tslint:disable-next-line: prefer-const
    let options: PrintOptions = {
      name: 'MyDocument',
      duplex: true,
      orientation: 'landscape',
      monochrome: true
    };


    this.printer.print().then(res => {
    }).catch(async err => {
      console.log('err', err);
    });


  }


}

